export const SET_SHOW_CHAT = 'SET_SHOW_CHAT';
export const AUTO_MINIMIZE_PROFILE_WORKBOX = 'AUTO_MINIMIZE_PROFILE_WORKBOX';

export const setShowChat = (show) => {
  return { type: SET_SHOW_CHAT, show }
}

export const setAutoMinimizeProfileWorkbox = (autoMinimize) => {
  return { type: AUTO_MINIMIZE_PROFILE_WORKBOX, autoMinimize }
}